import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FontScaleService {
  private readonly storageKey = 'app_font_scale';
  private readonly min = 0.85;
  private readonly max = 1.3;
  private readonly step = 0.05;
  scale = 1;

  constructor() {
    this.scale = this.readStored();
    this.apply();
  }

  get canDecrease(): boolean {
    return this.scale > this.min + 0.001;
  }

  get canIncrease(): boolean {
    return this.scale < this.max - 0.001;
  }

  decrease(): void {
    this.set(this.scale - this.step);
  }

  increase(): void {
    this.set(this.scale + this.step);
  }

  private set(value: number): void {
    const next = Math.min(this.max, Math.max(this.min, this.round(value)));
    if (next === this.scale) return;
    this.scale = next;
    localStorage.setItem(this.storageKey, String(this.scale));
    this.apply();
  }

  private apply(): void {
    document.documentElement.style.setProperty('--app-font-scale', String(this.scale));
  }

  private readStored(): number {
    const raw = Number(localStorage.getItem(this.storageKey));
    if (!Number.isFinite(raw)) return 1;
    return Math.min(this.max, Math.max(this.min, this.round(raw)));
  }

  private round(value: number): number {
    return Math.round(value * 100) / 100;
  }
}
